import KuikaSmallSpinner from "../../../ui-kit/kuika-small-spinner/kuika-small-spinner";
import "./symbol-dropdown-loading.scss";

// The empty state a symbol group's dropdown shows while its keys are still being
// fetched. Six action panels (bag / cache reads and removes, plus their has-key
// checks) each carried their own copy of this markup with the layout written
// inline; it is one component so the spinner, its box and its height stay the same
// in all of them.
//
// This is the same shape the in-cell data-type picker uses for its own catalogue
// fetch: a centred `KuikaSmallSpinner` in a box with a minimum height. The overlay
// spinner (`KuikaSpinnerSmall`) is the wrong primitive here — it positions its
// indicator over CHILDREN, and a dropdown's empty state has none, so it would
// collapse to nothing.
const SymbolDropdownLoading = (): JSX.Element => {
  return (
    <div className="kuika-symbol-dropdown__loading">
      <KuikaSmallSpinner spinning />
    </div>
  );
};

export default SymbolDropdownLoading;
